class HeroCarouselReveal extends HTMLElement {
  constructor() {
    super();
    this.animation = null;
    this.fallbackTimer = null;
  }

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.showFallback();
      return;
    }

    if (document.readyState === 'complete') {
      this.init();
    } else {
      window.addEventListener('load', () => this.init());
    }

    /* Safety fallback — reveal after 3s only if GSAP never initialises */
    this.fallbackTimer = setTimeout(() => this.showFallback(), 3000);
  }

  getGSAP() {
    if (typeof window !== 'undefined' && window.gsap && typeof window.gsap.to === 'function') {
      return window.gsap;
    }
    if (typeof window !== 'undefined' && window.GSAP && typeof window.GSAP.to === 'function') {
      return window.GSAP;
    }
    if (typeof window !== 'undefined' && window.GreenSockGlobals && window.GreenSockGlobals.gsap) {
      return window.GreenSockGlobals.gsap;
    }
    if (typeof gsap !== 'undefined' && typeof gsap.to === 'function') {
      return gsap;
    }
    return null;
  }

  waitForGSAP() {
    return new Promise((resolve) => {
      if (this.getGSAP()) {
        resolve();
        return;
      }

      /* Poll for GSAP availability — CDN defer scripts may not have executed yet */
      var attempts = 0;
      var check = setInterval(() => {
        attempts++;
        if (this.getGSAP() || attempts > 50) {
          clearInterval(check);
          resolve();
        }
      }, 100);
    });
  }

  async init() {
    await this.waitForGSAP();
    const gsapLib = this.getGSAP();

    if (!gsapLib) {
      this.showFallback();
      return;
    }

    /* GSAP loaded — cancel the safety fallback so it doesn't interfere */
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
      this.fallbackTimer = null;
    }

    var firstSlide = document.querySelector('.hero-slide[data-slide-index="0"]:not(.swiper-slide-duplicate)');
    if (!firstSlide) return;

    var title = firstSlide.querySelector('.hero-slide__title');
    var subtitle = firstSlide.querySelector('.hero-slide__subtitle');
    var cta = firstSlide.querySelector('.hero-slide__cta');
    var targets = [title, subtitle, cta].filter(Boolean);
    if (!targets.length) return;

    this.animation = gsapLib.fromTo(targets,
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.2,
        ease: 'power2.out'
      }
    );
  }

  showFallback() {
    var firstSlide = document.querySelector('.hero-slide[data-slide-index="0"]');
    if (!firstSlide) return;
    var els = firstSlide.querySelectorAll('.hero-slide__title, .hero-slide__subtitle, .hero-slide__cta');
    els.forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  disconnectedCallback() {
    if (this.animation && this.animation.kill) {
      this.animation.kill();
    }
  }
}

if (!customElements.get('hero-carousel-reveal')) {
  customElements.define('hero-carousel-reveal', HeroCarouselReveal);
}

